<template>
<div>
  <div class="minimal w-full flex justify-between max-w-sm mx-auto" id="menu-content">
    <div class="point text-center md:my-0 cursor-pointer " style="width:49%" :class="{active: isActive(index)}" v-for="(tab, index) in tabs" :key="tab.$attrs.title" v-on:click="(ev) => showTab(index)">
      <h3 class="inline-block py-1 pb-2 pt-5 text-gray-600">{{ tab.$attrs.title }}</h3>
    </div>
  </div>
  <div>
    <slot></slot>
  </div>
</div>
</template>

<style>

.active h5 {}
</style>

<script>
import Tab from './Tab';
import EventBus from '../EventBus';

export default {
  components: {
    Tab,
  },
  data() {
    return {
      tabs: [],
      current: 0,

    }
  },
  mounted() {
    console.log(this.$children);
    this.tabs = this.$children.filter(child => child.$options._componentTag === 'tab');
    let hash = window.location.hash.replace(/#/g, '').replace(/-/g, ' ');
    this.$nextTick(() => EventBus.$emit('craft:tab-change'));

    let fromHash = false;
    if (hash) {
      this.tabs.forEach((tab, index) => {
        if (tab.$attrs.title === hash) {
          tab.show = true;
          this.current = index;
          fromHash = true
        }
      })
    }

    if (!fromHash)
      this.tabs[0].show = true;

  },
  methods: {
    showTab(tabIndex) {
      this.tabs.forEach((tab, index) => {
        if (index === tabIndex) {
          tab.show = true;
        } else {
          tab.show = false;
        }
      })
      this.current = tabIndex;
      this.$nextTick(() => EventBus.$emit('craft:tab-change'));
    },
    isActive(index) {
      return index === this.current
    }
  }
}
</script>
